import { BankOutlined, HomeOutlined, RightOutlined, TeamOutlined } from '@ant-design/icons';
import { Card, Grid, Tag, Typography } from 'antd';
import type { ReactNode } from 'react';
import type { OrganisationSearchHit } from './organisationSearch';
import { orgCardShadow } from './organisationsUi';

const kindMeta: Record<
  OrganisationSearchHit['kind'],
  { color: string; icon: ReactNode }
> = {
  organisation: { color: 'blue', icon: <TeamOutlined /> },
  company: { color: 'geekblue', icon: <BankOutlined /> },
  farm: { color: 'green', icon: <HomeOutlined /> },
};

type OrgSearchResultCardProps = {
  hit: OrganisationSearchHit;
  kindLabel: string;
  onClick: () => void;
};

export function OrgSearchResultCard({ hit, kindLabel, onClick }: OrgSearchResultCardProps) {
  const screens = Grid.useBreakpoint();
  const isCompact = !screens.sm;
  const meta = kindMeta[hit.kind];
  const detail = hit.detail?.trim();

  return (
    <Card
      hoverable
      onClick={onClick}
      style={{ borderRadius: 8, boxShadow: orgCardShadow, border: 'none' }}
      styles={{
        body: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 16,
          padding: isCompact ? '14px 16px' : '16px 20px',
        },
      }}
    >
      <div style={{ display: 'flex', gap: 12, minWidth: 0, alignItems: 'center', flex: 1 }}>
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: 10,
            background: '#f2f4f7',
            color: '#475467',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            fontSize: 16,
          }}
        >
          {meta.icon}
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
            <Typography.Text strong style={{ fontSize: 16, wordBreak: 'break-word' }}>
              {hit.label}
            </Typography.Text>
            <Tag color={meta.color} style={{ margin: 0 }}>
              {kindLabel}
            </Tag>
          </div>
          {detail ? (
            <Typography.Text type="secondary" style={{ display: 'block', marginTop: 4, fontSize: 14 }}>
              {detail}
            </Typography.Text>
          ) : null}
        </div>
      </div>
      {hit.kind === 'farm' ? <RightOutlined style={{ color: '#98a2b3', flexShrink: 0 }} /> : null}
    </Card>
  );
}
